// referral.js - Auto apply discount codes based on advocate referral token.
(function() {
  try {
    // Detect referral token – support both the new `?r=<token>` query param and the legacy `/r/<token>` path.
    var urlParams = new URLSearchParams(window.location.search);
    var token = urlParams.get('r');

    // NEW: Capture encoded email from the URL and record invite link click
    var email = urlParams.get('email');
    if (email) {
      try {
        // Decode Base64 (including URL-safe flavor) email string
        function decodeBase64Email(str) {
          var cleaned = str.replace(/-/g, '+').replace(/_/g, '/');
          while (cleaned.length % 4 !== 0) cleaned += '='; // pad for proper length
          var decoded = atob(cleaned);
          return decoded;
        }

        var emailParam = decodeBase64Email(email.trim());
        // Fire-and-forget API request – should not block any UI/redirect logic
        fetch('https://api.wildgrain.com/api/referrals/invite/clicked', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: emailParam })
        }).catch(function(err) {
          console.warn('Failed to record invite link click', err);
        });

      } catch (emailDecodeErr) {
        console.warn('Failed to decode email parameter', emailDecodeErr);
      }
    }

    if (!token) {
      var match = window.location.pathname.match(/^\/r\/([A-Za-z0-9_-]+)\/?$/);
      if (match) token = match[1];
    }

    if (!token) return; // Not a referral URL

    // ---------------------------------------------------------------------------
    // Early-exit: If the visitor already has a Wildgrain referral discount code
    // stored (codes always start with "FR-"), we don't need to request another
    // one for 7 days (cookie TTL is set to 7 days when originally issued).
    // ---------------------------------------------------------------------------

    // Helper to read a cookie value
    function getCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
      }
      return null;
    }

    var cachedCode = getCookie('wg_discount_code');
    if (cachedCode && cachedCode.indexOf('FR-') === 0) {
      // We already have a recent referral code – skip the API call entirely.
      console.log('[Referral] Existing referral code found (', cachedCode, '), skipping new code request.');

      // Build redirect path to ensure the discount is re-applied in case the
      // visitor cleared their cart or is beginning a fresh session.
      var redirectUrl = '/discount/' + encodeURIComponent(cachedCode) + '?redirect=' + encodeURIComponent('/');

      // Directly send them to the discount URL instead of showing the capture
      // modal again – their details were already collected previously.
      window.location.replace(redirectUrl);
      return; // Stop further execution of the referral script
    }

    // Helper: build and show the referral claim modal
    function showReferralModal(advocateName, discountCode, discountUrl) {
      // Ensure jQuery is available
      if (!window.jQuery) {
        console.error('jQuery is required for the referral modal.');
        window.location.replace(discountUrl); // Fallback to direct redirect
        return;
      }

      // Helper to load jQuery Modal plugin (if not already present)
      function ensureModalPlugin(callback) {
        if (jQuery.fn.modal) return callback();

        var cssId = 'jquery-modal-css';
        if (!document.getElementById(cssId)) {
          var link = document.createElement('link');
          link.id = cssId;
          link.rel = 'stylesheet';
          link.href = 'https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.css';
          document.head.appendChild(link);
        }

        var script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.js';
        script.onload = callback;
        document.head.appendChild(script);
      }

      ensureModalPlugin(function() {
        // Build modal markup (similar structure to other modals in theme)
        var $modal = jQuery('<div>', {
          id: 'referral-modal',
          class: 'modal text-center',
          style: 'padding: 30px!important; box-shadow: rgb(113 45 33 / 100%) 0 -20px 100px -20px;',
          html:
            '<h4 id="referral-title" class="section-heading red idler mb-0 mt-s pt-s pb-s w-100" style="text-wrap:balance;">' +
            (advocateName ? ('You\'ve been referred by ' + advocateName + '!') : 'You\'ve been referred!') +
            '</h4>' +
            '<p id="referral-subtitle" class="mb-s" style="max-width: 500px; margin: 0 auto; text-wrap:balance;">Enter your details below to claim your exclusive discount.</p>' +
            '<form id="referral-form" class="w-100 section-form pb-lg" novalidate>' +
            '  <div class="mb-s" style="display:flex; flex-direction:column; gap:8px;">' +
            '    <input placeholder="First Name" name="firstName" required class="flex-1 min-w-0 wg-textarea" type="text" />' +
            '    <input placeholder="Last Name" name="lastName" required class="flex-1 min-w-0 wg-textarea" type="text" />' +
            '  </div>' +
            '  <input placeholder="Email" name="email" required class="w-100 mb-s wg-textarea" type="email" />' +
            '  <button type="submit" class="btn w-100 mb-m"><b>Claim Discount</b></button>' +
            '</form>' +
            '<div id="discount-success" class="hidden">' +
            '    <h4 class="section-heading red idler mb-0 mt-s pt-s pb-s w-100" style="text-wrap:balance;">Discount Applied</h4>' +
            '    <div class="w-100 mb-s" style="max-width: 500px; margin: 0 auto; display:flex; align-items: center; gap:8px;">' +
            '      <input id="discount-code-input" readonly type="text" value=""' +
            '        class="px-s py-xs border border-solid border-red rounded-l bg-white text-red font-mono truncate"' +
            '        style="flex:1 1 auto; min-width:0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" />' +
            '      <button id="copy-discount-code" class="copy-btn bg-red text-white px-s py-xs rounded-r" aria-label="Copy discount code"' +
            '        style="display:flex; align-items:center; justify-content:center; flex-shrink:0;">' +
            '        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">' +
            '          <path d="M16 1H4C2.9 1 2 1.9 2 3v14c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2V3c0-1.1-0.9-2-2-2zM4 17V3h12v14H4z" />' +
            '          <path d="M20 5h-2v14H8v2c0 1.1 0.9 2 2 2h8c1.1 0 2-0.9 2-2V7c0-1.1-0.9-2-2-2z" />' +
            '        </svg>' +
            '      </button>' +
            '    </div>' +
            '    <a href="#" id="continue-shopping" class="btn w-100"><b>Continue</b></a>' +
            '  </div>'
        });

        // Append only once
        if (!document.getElementById('referral-modal')) {
          jQuery('body').append($modal);
        }
        // Ensure success section hidden initially
        $modal.find('#discount-success').hide();
        // Open modal
        $modal.modal({ escapeClose: false, clickClose: false, showClose: false });
        // Override theme opacity settings (wildgrain theme sets .modal {opacity:0})
        $modal.css('opacity', 1);

        var $form = $modal.find('#referral-form');
        // Prefill email if we captured it from URL
        if (typeof emailParam !== 'undefined' && emailParam) {
          $form.find('input[name="email"]').val(emailParam);
        }
        var $success = $modal.find('#discount-success');
        var $codeInput = $modal.find('#discount-code-input');
        var $copyBtn = $modal.find('#copy-discount-code');
        var $continueBtn = $modal.find('#continue-shopping');
        // New: capture original title and subtitle elements so we can hide them on success
        var $title = $modal.find('#referral-title');
        var $subtitle = $modal.find('#referral-subtitle');

        $form.on('submit', function(e) {
          e.preventDefault();
          if (!$form[0].checkValidity()) {
            $form[0].reportValidity();
            return;
          }

          // NEW: Notify backend that the invite has been used
          try {
            var email = $form.find('input[name="email"]').val().trim();
            var firstName = $form.find('input[name="firstName"]').val().trim();
            var lastName = $form.find('input[name="lastName"]').val().trim();

            // Fire-and-forget request – UI flow should not be blocked by this call
            fetch('https://api.wildgrain.com/api/referrals/invite', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                email: email,
                first_name: firstName,
                last_name: lastName,
                discount_code: discountCode
              })
            }).catch(function(err) {
              console.warn('Failed to notify invite usage', err);
            });
          } catch (inviteErr) {
            console.warn('Invite POST exception', inviteErr);
          }

          // Show success state
          $codeInput.val(discountCode);
          $form.hide();
          // Hide the initial title/subtitle for a cleaner second step
          $title.hide();
          $subtitle.hide();
          $success.show();

          // Copy to clipboard functionality
          $copyBtn.on('click', function(ev) {
            ev.preventDefault();
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(discountCode).then(function() {
                // Provide quick visual feedback
                $copyBtn.addClass('opacity-50');
                setTimeout(function(){ $copyBtn.removeClass('opacity-50'); }, 800);
              }).catch(function(err) {
                console.warn('Clipboard copy failed', err);
              });
            }
          });

          $continueBtn.on('click', function(e2) {
            e2.preventDefault();
            window.location.replace(discountUrl);
          });
        });
      });
    }

    // Fetch a fresh discount code from Wildgrain API
    fetch('https://api.wildgrain.com/api/referrals/discount-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ token: token })
    })
      .then(function(res) {
        if (!res.ok) throw res; // Will be caught below
        return res.json();
      })
      .then(function(data) {
        if (data && data.code) {
          // Build redirect path – append advocate name for downstream display if available
          var redirectPath = '/';
          if (data.advocate_name) {
            redirectPath += '?advocate=' + encodeURIComponent(data.advocate_name);
          }
          // Prepare Shopify discount link to auto-apply code (will redirect after form submission)
          var redirectUrl = '/discount/' + encodeURIComponent(data.code) + '?redirect=' + encodeURIComponent(redirectPath);

          // NEW: Persist discount details so header announcement bar can pick them up
          try {
            var sevenDays = 7;
            // Support multiple possible field names from API (snake_case and camelCase)
            var amount = data.amount || data.discount_amount || data.discountAmount || data.value || null;
            var qty = data.qty || data.discount_qty || data.discountQty || 1;

            // Helper to set cookie using jQuery.cookie if available, otherwise fallback to native API
            function setCookie(name, value, days) {
              if (window.jQuery && typeof jQuery.cookie === 'function') {
                jQuery.cookie(name, value, { expires: days, path: '/' });
              } else {
                var expires = '';
                if (days) {
                  var date = new Date();
                  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                  expires = '; expires=' + date.toUTCString();
                }
                document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
              }
            }

            // Store discount cookies so the logic in header.liquid (wg-utms snippet) can surface the banner
            setCookie('wg_discount_code', data.code, sevenDays);
            if (amount !== null) setCookie('wg_discount_amount', amount, sevenDays);
            if (qty !== null) setCookie('wg_discount_qty', qty, sevenDays);

            // Immediately surface the announcement bar (without waiting for a page refresh)
            var bannerEl = document.querySelector('.announcement-bar');
            var messageEl = document.getElementById('discount_message');
            if (bannerEl && messageEl && amount !== null) {
              var bannerText = qty > 1 ? '🙌 APPLIED: $' + amount + ' OFF ' + qty + ' BOXES!' : '🙌 APPLIED: $' + amount + ' OFF YOUR BOX!';
              messageEl.textContent = bannerText;
              bannerEl.style.display = 'block';
            }
          } catch (cookieErr) {
            console.warn('Failed to set discount cookies', cookieErr);
          }

          // Show modal instead of immediate redirect
          showReferralModal(data.advocate_name, data.code, redirectUrl);
        } else {
          // No code field present – fallback
          window.location.replace('/');
        }
      })
      .catch(function(err) {
        // On 400/404 or network errors, just send visitor to homepage
        console.error('Referral discount lookup failed', err);
        window.location.replace('/');
      });
  } catch (e) {
    console.error('Referral script error', e);
  }
})(); 